/*-----------------------------------------------------------------------------------*/
/*  START
/*-----------------------------------------------------------------------------------*/
document.readyState !== "loading"
    ? startJs()
    : document.addEventListener("DOMContentLoaded", () =>
          setTimeout(startJs(), 3000)
      );
function startJs() {
    console.log("STARTING main js");

    //js for yebo mobile apps
    var swiper = new Swiper(".apps-slider-list", {
        slidesPerView: 5,
        spaceBetween: 15,
        allowTouchMove: true,
        breakpoints: {
            250: {
                slidesPerView: 1,
            },
            300: {
                slidesPerView: 1.5,
            },

            320: {
                slidesPerView: 2.5,
            },

            568: {
                slidesPerView: 3.5,
            },

            768: {
                slidesPerView: 4.3,
            },

            1200: {
                slidesPerView: 5.3,
            },
        },
        pagination: {
            el: ".apps-slider .swiper-pagination",
            clickable: true,
        },
    });

    document.querySelectorAll(".faq-q").forEach((button) => {
        button.addEventListener("click", () => {
            const accordionItem = button.parentElement;
            const content = button.nextElementSibling;
            const icon = button.querySelector(".icon");
            const isMobile = window.innerWidth <= 768;
            const paddingValue = isMobile ? "25px" : "40px";

            if (accordionItem.classList.contains("active")) {
                accordionItem.classList.remove("active");
                content.style.maxHeight = "0";
                content.style.paddingTop = "0";
                // content.style.paddingBottom = '0';
                icon.src = "../../android-app/images/svg/faq-closed.svg";
            } else {
                accordionItem.classList.add("active");
                content.style.maxHeight = content.scrollHeight + "px";
                content.style.paddingTop = paddingValue;
                // content.style.paddingBottom = paddingValue;
                icon.src = "../../android-app/images/svg/faq-open.svg";
            }
        });
    });

    var dropdownToggle = document.querySelector(".dropdown-toggle");
    var dropdownMenu = document.querySelector(".dropdown-menu");
    var tabclass = document.querySelector(".tab-grid");

    // Show/hide dropdown menu on click
    if (dropdownToggle && dropdownMenu) {
        dropdownToggle.addEventListener("click", function () {
            dropdownMenu.style.display = dropdownMenu.style.display === "none" ? "block" : "none";
        });
    }

    // Set selected option on click
    if (dropdownToggle && dropdownMenu) {
    dropdownMenu.addEventListener("click", function (e) {
        if (e.target.tagName === "LI") {
            dropdownToggle.textContent = e.target.textContent;
            var activetab = e.target.className;
            tabclass.classList.remove("active");
            var tab_1 = document.getElementById("tab_1");
            var tab_2 = document.getElementById("tab_2");
            var tab_3 = document.getElementById("tab_3");
            if (tab_1) {
                document.getElementById("tab_1").classList.remove("active");
            }
            if (tab_2) {
                document.getElementById("tab_2").classList.remove("active");
            }
            if (tab_3) {
                document.getElementById("tab_3").classList.remove("active");
            }

            document.getElementById(activetab).classList.add("active");

            dropdownMenu.style.display = "none";
        }
    });
    }

    const rd_more = document.getElementsByClassName("readMore")[0];
    if (rd_more) {
        rd_more.addEventListener("click", function () {
            $(".content-footer").find("p,h2,h3,h4,h5").css("display", "block");
            const removeDiv =
                document.getElementsByClassName("footer-overlay")[0];
            removeDiv.remove();
        });
    }

    /**
     * Tabs
     */

    function Tabs() {
        var bindAll = function () {
            var menuElements = document.querySelectorAll("[data-tab]");
            for (var i = 0; i < menuElements.length; i++) {
                menuElements[i].addEventListener("click", change, false);
            }
        };

        var clear = function () {
            var menuElements = document.querySelectorAll("[data-tab]");
            for (var i = 0; i < menuElements.length; i++) {
                menuElements[i].classList.remove("active");
                var id = menuElements[i].getAttribute("data-tab");
                document.getElementById(id).classList.remove("active");
            }
        };

        var change = function (e) {
            clear();
            e.preventDefault();
            e.target.classList.add("active");
            var id = e.currentTarget.getAttribute("data-tab");
            document.getElementById(id).classList.add("active");
        };

        bindAll();
    }

    var connectTabs = new Tabs();

    var a = document.querySelectorAll(".text-gradiant .tabs li a");
    for (var i = 0, length = a.length; i < length; i++) {
        a[i].onclick = function () {
            var b = document.querySelector(".text-gradiant .tabs a.active");
            b.classList.remove("active");
            this.classList.add("active");
        };
    }

    if (document.getElementsByClassName("targetvalue_player").length > 0) {
        $(document).ready(function () {
            var counterElement_player = $(".targetvalue_player").val();
            result = parseFloat(counterElement_player);
            result = result.formatMoney(2, ".", ",").toString();
            var cleanFloat = result.split(",").join("");
            initial_jackpot = cleanFloat; // setting global to not to parse it from html later on.
            var formatted = RotatingCounter_player.format(result);
            $(".jackpot-text_player").children("span").html(formatted);
            RotatingCounter_player.start();
            $("jackpot-text").slideDown();
        });
    }

    /**
     * Newest Games
     */

    var swiper = new Swiper(".newestGames", {
        loop: true,
        slidesPerView: 6,
        paginationClickable: false,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: 6,
            },
            1200: {
                slidesPerView: 6,
            },
            1080: {
                slidesPerView: 5,
            },
            992: {
                slidesPerView: 4,
            },
            850: {
                slidesPerView: 4,
            },
            767: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            320: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            280: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
        },
    });

    /**
     * Jackpot Slider
     */

    var swiper = new Swiper(".JP-winner", {
        loop: true,
        slidesPerView: 5,
        paginationClickable: false,
        spaceBetween: 20,
        breakpoints: {
            1500: {
                slidesPerView: 5,
            },
            1300: {
                slidesPerView: 5,
            },
            1150: {
                slidesPerView: 4,
            },
            1025: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            850: {
                slidesPerView: 4,
            },
            767: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            514: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            320: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
            280: {
                slidesPerView: 2.5,
                spaceBetween: 10,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next2",
            prevEl: ".swiper-button-prev2",
        },
    });

    var swiper2 = new Swiper(".big-win", {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: 5,
            },
            1300: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3,
            },
            480: {
                slidesPerView: 2,
            },
            320: {
                slidesPerView: 2,
            },
            280: {
                slidesPerView: 2,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next4",
            prevEl: ".swiper-button-prev4",
        },
    });

    function removeElementsByClass(className) {
        const elements = document.querySelectorAll("." + className);
        elements.forEach((element) => element.remove());
    }

    const swiper1 = new Swiper(".hero", {
        autoplay: true,
        loop: true,
        // speed: 500,
        // spaceBetween: 2000,
        pagination: {
            el: ".swiper-pagination",
        },
        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    var swiper5 = new Swiper(".testomonials", {
        effect: "cube",
        loop: true,
        grabCursor: true,
        autoplay: {
            delay: 6000,
        },
        cubeEffect: {
            shadow: false,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94,
        },
    });

    const menuopen = document.querySelector(".hamburger-icon");
    const sidebar = document.querySelector(".sidebar-menu");
    const overlay = document.querySelector(".sidebar-overlay");
    const sidebarclose = document.querySelector(".closebtn");
    const menuItem = document.querySelector(".menu-item");
    const bodyOverflowHidden = document.querySelector("body");
    const searchOpen = document.querySelector(".input-search");
    const searchModal = document.getElementById("search-modal");
    const closeModal = document.getElementById("modal-close-btn");
    const searchopen404 = document.getElementById("search-open404");

    menuopen.addEventListener("click", function (e) {
        e.stopPropagation();
        sidebar.classList.add("sidebar-active");
        bodyOverflowHidden.classList.add("overflow-hidden");
        menuItem.classList.add("overflow-y");
        overlay.style.display = "block";
    });

    sidebarclose.addEventListener("click", function (e) {
        e.stopPropagation();
        sidebar.classList.remove("sidebar-active");
        bodyOverflowHidden.classList.remove("overflow-hidden");
        menuItem.classList.remove("overflow-y");
        overlay.style.display = "none";
    });

    searchOpen.addEventListener("click", (e) => {
        e.stopPropagation();
        searchModal.style.display = "block";
        bodyOverflowHidden.classList.add("overflow-hidden");
    });

    closeModal.addEventListener("click", (e) => {
        e.stopPropagation();
        searchModal.style.display = "none";
        bodyOverflowHidden.classList.remove("overflow-hidden");
    });

    searchopen404.addEventListener("click", (e) => {
        e.stopPropagation();
        searchModal.style.display = "block";
        bodyOverflowHidden.classList.add("overflow-hidden");
    });

    function noenter(e) {
        e = e || window.event;
        var key = e.keyCode || e.charCode;
        return key !== 13;
    }

    var swiper6 = new Swiper(".swiper-mobile", {
        loop: true,
        slidesPerView: 5,
        paginationClickable: false,
        spaceBetween: 20,
        allowTouchMove: false,
        breakpoints: {
            1350: {
                slidesPerView: 5,
                //          allowTouchMove: true,
            },
            768: {
                slidesPerView: 3,
                allowTouchMove: true,
            },
            490: {
                slidesPerView: 2,
                allowTouchMove: true,
            },
            320: {
                slidesPerView: 1,
                allowTouchMove: true,
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    var swiper7 = new Swiper(".swiper-step", {
        loop: false,
        slidesPerView: 3,
        paginationClickable: false,
        spaceBetween: 0,
        allowTouchMove: false,
        breakpoints: {
            1500: {
                slidesPerView: 3,
            },
            1300: {
                slidesPerView: 3,
            },
            767: {
                slidesPerView: 3,
                allowTouchMove: true,
            },
            490: {
                slidesPerView: 2,
                allowTouchMove: true,
                autoHeight: true,
            },
            320: {
                slidesPerView: 1,
                allowTouchMove: true,
                autoHeight: true,
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}
